import { PrismaticContext, Prismatic } from "@/context/PrismaticContext";
import { useContext } from "react";

export const usePrismatic = (): Prismatic => useContext(PrismaticContext);
